(() => {
  const activate = () => {
    const root = document.querySelector('[data-sv2-root]');
    if (!root) return;
    document.documentElement.classList.add('sv2-ready');

    document.querySelectorAll('.sv2-review-rail').forEach((rail) => {
      const update = () => {
        rail.classList.toggle('is-at-start', rail.scrollLeft < 8);
        rail.classList.toggle('is-at-end', rail.scrollLeft + rail.clientWidth >= rail.scrollWidth - 8);
      };
      update();
      rail.addEventListener('scroll', update, { passive: true });
    });
  };

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', activate, { once: true });
  else activate();
})();
